import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WorkCenterJobQueueView } from "src/components/views/erp/production/jobQueue/WorkCenterJobQueueView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/production/workCenterJobQueue")({
	staticData: { title: i18n.t("work_center_job_queue"), legacyViewKey: "workCenterJobQueuePage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <WorkCenterJobQueueView isActive={isActive} />;
}
